import styled from 'styled-components';

export const TreeWrapper = styled.div`
  .rc-tree {
    .rc-tree-treenode {
      display: flex;

      .rc-tree-node-content-wrapper {
        display: flex;
        flex-grow: 1;

        .rc-tree-title {
          flex-grow: 1;

          > div {
            display: initial;
          }
          [data-search='highlighted'] {
            font-style: italic;
            color: #8b0000;
            font-weight: 700;
          }
        }
      }
    }
  }
`;
